import { computed, nextTick, onBeforeUnmount, onMounted, ref } from 'vue';
import { useDebounceFn } from '@vueuse/core';
import { DsrConstants } from '../constants';

export enum DsrLayout {
  ShowAll = 'ShowAll',
  HideRightSide = 'HideRightSide',
  HideBothSides = 'HideBothSides',
  ContentOnly = 'ContentOnly',
}

export function useLayout() {
  const totalContentPadding = DsrConstants.contentPadding * 2;
  const totalRightWidth = DsrConstants.rightSideWidth + DsrConstants.sideMargin;
  const totalLeftWidth = DsrConstants.navigationWidth + DsrConstants.sideMargin;

  const layout = ref(DsrLayout.ShowAll);

  const updateDsrLayout = () => {
    if (
      document.body.offsetWidth - (totalLeftWidth + totalRightWidth + totalContentPadding) >=
      600
    ) {
      layout.value = DsrLayout.ShowAll;
    } else if (document.body.offsetWidth - (totalLeftWidth + totalContentPadding) >= 600) {
      layout.value = DsrLayout.HideRightSide;
    } else if (document.body.offsetWidth > 600) {
      layout.value = DsrLayout.HideBothSides;
    } else {
      layout.value = DsrLayout.ContentOnly;
    }
  };

  const showRightSide = computed(
    () =>
      ![DsrLayout.HideRightSide, DsrLayout.HideBothSides, DsrLayout.ContentOnly].includes(
        layout.value
      )
  );

  const showLeftSide = computed(
    () => ![DsrLayout.HideBothSides, DsrLayout.ContentOnly].includes(layout.value)
  );

  const showMobileView = computed(() => layout.value === DsrLayout.ContentOnly);

  const debounceUpdateLayout = useDebounceFn(updateDsrLayout, 200);

  onMounted(async () => {
    await nextTick();
    updateDsrLayout();
    addEventListener('resize', debounceUpdateLayout);
  });

  onBeforeUnmount(() => {
    removeEventListener('resize', debounceUpdateLayout);
  });

  return {
    showMobileView,
    showRightSide,
    showLeftSide,
    updateDsrLayout,
  };
}
